import React from 'react';
import imagePlaceholder from '@/assets/images/fair-home-panel-banner-image.png';
import BackgroundImage from '@/themes/components/BackgroundImage';

const HomeHeaderBackgroundImage = ({ children }) => (
  <BackgroundImage
    className="aridhia-home-search-banner"
    codes={[{ code: 'fair-home-panel-banner-image.png', local: imagePlaceholder }]}
  >
    <div className="flex justify-center flex-column items-center">
      {children}
    </div>
  </BackgroundImage>
);

export default HomeHeaderBackgroundImage;
